/**
 * The attribute an element carries when it strikes its own text through, in a colour its own change
 * chose: a word a revision deleted, a fee a removal took out, a team member who left the team.
 *
 * A removed row strikes every cell in its party's colour (`removed-row-redline.ts`), but not these. Such
 * a line is older than the row's removal, or another party's, and says so by its colour, so the row
 * leaves the element and everything in it alone (#7084).
 */
export const OWN_STRIKE_ATTRIBUTE = "data-own-strike";

/** The attribute to spread onto an element that strikes its own text when `struck`, or none. */
export function ownStrikeAttribute(struck: boolean | undefined): { [OWN_STRIKE_ATTRIBUTE]?: "" } {
  return struck ? { [OWN_STRIKE_ATTRIBUTE]: "" } : {};
}
